<google-map *ngIf="coordenada" [center]="coordenada" [options]="mapOptions" width="100%" [height]="mapHeight">
  <map-marker [position]="coordenada" [options]="markerOptions"></map-marker>
</google-map>